<template>
    <header>
        <div class="fixed-sn" >
            <!-- Sidebar navigation -->
        <div id="slide-out" class="side-nav fixed" :class="{'active' : sidebarOpen}">
            <ul class="custom-scrollbar">
                <!-- Logo -->
                <li>
                    <div class="logo-wrapper waves-light " v-on:click="toggleSideNav()">
                        <router-link :to="{ name: 'home' }" class="navbar-brand"><img src="@/assets/logo.gif" class="img-fluid flex-center"></router-link>

                    </div>
                </li>
                <!--/. Logo -->
                <!-- Side navigation links -->
                <li class="h-100" style="overflow-y: auto;">

                    <ul  class="navbar-nav collapsible collapsible-accordion" v-if="userStatus == 0"> <!--  v-if="userStatus == 0" -->
                        <li class="nav-item" :class="{'active': subIsActive('/angebote/freigeben'), 'new--angebot': newAngebote}" v-on:click="toggleSideNav()">
                            <router-link :to="{ name: 'angeboteFreigeben'}"  class="nav-links">Angebote freigeben <mdb-icon icon="info-circle" color="black" v-if="newAngebote"/></router-link>
                        </li>
                        <li class="nav-item" :class="{'active': subIsActive('/angebote/aktiv')}" v-on:click="toggleSideNav()">
                            <router-link :to="{ name: 'angebote'}"  class="nav-links">Aktive Angebote</router-link>
                        </li>
                        <li class="nav-item" :class="{'active': subIsActive('/angebote/inaktive')}" v-on:click="toggleSideNav()">
                            <router-link :to="{ name: 'angeboteInaktive'}"  class="nav-links">Inaktive Angebote</router-link>
                        </li>
                        <li class="nav-item" :class="{'active': subIsActive('/angebote/abgelehnt')}" v-on:click="toggleSideNav()">
                            <router-link :to="{ name: 'angeboteAbgelehnt'}"  class="nav-links">Abgelehnte Angebote</router-link>
                        </li>
                        <li class="nav-item" :class="{'active': subIsActive('/angebote/inBearbeitung')}" v-on:click="toggleSideNav()">
                            <router-link :to="{ name: 'angeboteBearbeitung'}"  class="nav-links">Angebote in Bearbeitung</router-link>
                        </li>
                        
                        <li class="nav-item" :class="{'active': subIsActive('/angebote/neu')}" v-on:click="toggleSideNav()">
                            <router-link :to="{ name: 'angeboteNeu'}"  class="nav-links">Neues Angebot</router-link>
                        </li>

                        <li class="nav-item" :class="{'active': subIsActive('/angebote/suche')}" v-on:click="toggleSideNav()">
                            <router-link :to="{ name: 'suche'}"  class="nav-links">Angebote suchen</router-link>
                        </li>
                        <li class="nav-item" :class="{'active': subIsActive('/angebote/merkliste')}" v-on:click="toggleSideNav()">
                            <router-link :to="{ name: 'merkliste'}"  class="nav-links">Merkliste</router-link>
                        </li>
                        <li class="nav-item" :class="{'active': subIsActive('/settings')}" v-on:click="toggleSideNav()">
                            <router-link :to="{ name: 'settings'}"  class="nav-links">Einstellungen</router-link>
                        </li>
                        <li class="nav-item" :class="{'active': subIsActive('/statistik')}" v-on:click="toggleSideNav()">
                            <router-link :to="{ name: 'statistik'}"  class="nav-links">Statistik</router-link>
                        </li>
                        <li class="nav-item" :class="{'active': subIsActive('/benutzerverwaltung')}" v-on:click="toggleSideNav()">
                          <router-link :to="{ name: 'benutzerverwaltung'}"  class="nav-links">Benutzerverwaltung</router-link>
                        </li>
                        <li class="nav-item" :class="{'active': subIsActive('/system-messages-mieter')}" v-on:click="toggleSideNav()">
                          <router-link :to="{ name: 'systemMessages'}"  class="nav-links">Benachrichtigungen Mieter</router-link>
                        </li>
                      <li class="nav-item" :class="{'active': subIsActive('/system-messages-vermieter')}" v-on:click="toggleSideNav()">
                        <router-link :to="{ name: 'systemMessagesVermieter'}"  class="nav-links">Benachrichtigungen Vermieter</router-link>
                      </li>
                    </ul>
                </li>
                <!--/. Side navigation links -->
            </ul>
            <div class="sidenav-bg mask-strong"></div>
        </div>
        <!--/. Sidebar navigation -->

        <nav class="navbar navbar-toggleable-md navbar-expand-lg scrolling-navbar double-nav mb-5">
            <!-- SideNav slide-out button -->
            <div class="float-left">
                <a href="#" data-activates="slide-out" class="button-collapse" v-on:click.prevent.stop="toggleSideNav()"><i class="fas fa-bars"></i></a>
            </div>
            <!-- Breadcrumb-->
           <!-- <div class="breadcrumb-dn mr-auto text-left">
                <p>Wohnungsdatenbank</p>
                <p>Albert-Ludwigs-Universität Freiburg</p>
            </div> -->
            <ul class="nav navbar-nav nav-flex-icons ml-auto">
                    <li class="nav-item">
                        <div v-if="loggedIn">
                            <router-link class="" :to="{ name: 'profil'}">Profil | </router-link>
                            <a href="#" @click="logout">Logout</a>
                        </div>
                        <div v-else>
                            <router-link :to="{ name: 'login'}">Login</router-link>
                        </div>
                    </li>
            </ul>
        </nav>
        <!-- /.Navbar -->
        </div>
        
    </header>
</template>

<script>
    import { authComputed } from '../../helpers/helper.js'
    import AngebotService from "@/services/AngebotService";

    export default {
        data(){
            return{
                adminmenu: 1,
                newAngebote: false,
              sidebarOpen: false,
            }
        },
        methods: {
          toggleSideNav(){
            console.log("Toggle Nav")
            this.sidebarOpen = !this.sidebarOpen;
          },
          subIsActive(input) {
                const paths = Array.isArray(input) ? input : [input]
                return paths.some(path => {
                    return this.$route.path.indexOf(path) === 0 // current path starts with this path string
                })
            },
            logout: function() {
                    this.$store.dispatch("logout")
                    .then(() => this.$router.push("/login"))
                    .catch(err => console.log(err));
            },
        },
        created() {
            AngebotService.getAngeboteFreigegeben()
                .then(response => {
                    let angebotData = response.data;
                    if(angebotData.length > 0){
                        this.newAngebote = true;
                    } else {
                        this.newAngebote = false;
                    }

                })
                .catch(error => {
                    console.log("There was an error:", error.response);
                });
        },
        computed: {
            ...authComputed
        }

    };
</script>
<style scoped lang="scss">
    .side-nav a{
        padding-left: 0px !important;
    }
    .nav-item.active a {
        background-color: rgba(0, 0, 0, 0.15);
    }
    .new--angebot{
        position: relative;
        color: black;
        .fas{

        }
        &.active{
            color: white;
        }
    }

    #slide-out{
      transition: all 0.4s ease-out;
      &.active{
        transform: translateX(0px) !important;
      }
    }

</style>
